import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import Component from './component'
import { login, attemptAutoLogin } from '../../ducks/auth'

function mapStateToProps (state, ownProps) { // eslint-disable-line no-unused-vars
  return {
    ...ownProps,
    loggedIn: state.auth.loggedIn,
    loggingIn: state.auth.loggingIn,
    didAttemptAutoLogin: state.auth.didAttemptAutoLogin,
    error: state.auth.error
  }
}

function mapDispatchToProps (dispatch) {
  return bindActionCreators({ login, attemptAutoLogin }, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(Component)



// WEBPACK FOOTER //
// ./ui/login/index.js